import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import MuiAccordion from '@material-ui/core/Accordion';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleDown } from '@fortawesome/free-solid-svg-icons';
import TopWidgetPanelTitle from './TopWidgetPanelTitle';
import TopWidgetPanelContainer from './TopWidgetPanelContainer';


const Accordion = withStyles({
  root: {
    borderRadius: '11px',
    position: 'static',
  },
})(MuiAccordion);

const TopWidgetPanelMobile = ({ data }) => {
  return (
    <Accordion>
      <AccordionSummary
        expandIcon={<FontAwesomeIcon icon={faAngleDown} />}
        aria-controls="top-widget-panel-content"
        id="top-widget-panel-header"
      >
        <TopWidgetPanelTitle />
      </AccordionSummary>
      <AccordionDetails>
        <TopWidgetPanelContainer data={data} />
      </AccordionDetails>
    </Accordion>
  );
};

export default TopWidgetPanelMobile;
